import { Translate } from '@heidi-pay/heidi-common-fe/types';
import { Tabs } from '@components/Tabs';
import { ITabData } from '@components/Tabs/types';
import { TabEventKeys } from '@utils/constants';

interface IMerchantDetailsTabs {
  OverviewTabComponent: JSX.Element;
  ReceivablesTabComponent: JSX.Element;
  translate: Translate;
}

export const MerchantDetailsTabs = ({
  OverviewTabComponent,
  ReceivablesTabComponent,
  translate,
}: IMerchantDetailsTabs) => {
  const overviewTab = {
    component: OverviewTabComponent,
    eventKey: TabEventKeys.MERCHANT_DETAILS_OVERVIEW,
    title: translate('OPS_PORTAL.TITLE.OVERVIEW'),
  };

  const receivablesTab = {
    component: ReceivablesTabComponent,
    eventKey: TabEventKeys.MERCHANT_DETAILS_RECEIVABLES,
    title: translate('OPS_PORTAL.TITLE.RECEIVABLES'),
  };

  const tabDataArray: ITabData[] = [overviewTab, receivablesTab];

  return (
    <Tabs
      initialTabKey={TabEventKeys.MERCHANT_DETAILS_OVERVIEW}
      tabsData={tabDataArray}
      tabsId="merchant-details-tabs"
    />
  );
};
